import { MenuItemIcon } from '@/components/MenuItem/MenuItemIcon';
import Top from '@/images/position/align/Top.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { alignElementsTop } from '../../../../actions/align/Top';

export const TopMenuItem = () => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;

    const handleClick = () => {
        alignElementsTop(selectedElements);
    };

    return <MenuItemIcon onClick={handleClick} src={Top} text="Top" />;
};
